import { defineBlocksWithJsonArray } from 'blockly/core';

const MATH_STYLE = 'math_blocks';

/**
 * Beginner Math helpers — Convert Range and Limit Value.
 * Number, arithmetic, and random remain the standard Blockly blocks.
 */
const mathBlockDefinitions = [
  {
    type: 'beginner_math_convert_range',
    message0: 'convert %1 from %2 – %3 to %4 – %5',
    args0: [
      { type: 'input_value', name: 'VALUE', check: 'Number' },
      { type: 'input_value', name: 'FROM_LOW', check: 'Number' },
      { type: 'input_value', name: 'FROM_HIGH', check: 'Number' },
      { type: 'input_value', name: 'TO_LOW', check: 'Number' },
      { type: 'input_value', name: 'TO_HIGH', check: 'Number' },
    ],
    inputsInline: true,
    output: 'Number',
    style: MATH_STYLE,
    tooltip: 'Changes a number from one range into another range.',
    helpUrl: '',
  },
  {
    type: 'beginner_math_limit_value',
    message0: 'limit %1 between %2 and %3',
    args0: [
      { type: 'input_value', name: 'VALUE', check: 'Number' },
      { type: 'input_value', name: 'LOW', check: 'Number' },
      { type: 'input_value', name: 'HIGH', check: 'Number' },
    ],
    inputsInline: true,
    output: 'Number',
    style: MATH_STYLE,
    tooltip: 'Keeps a number from going below the low value or above the high value.',
    helpUrl: '',
  },
];

export function registerBeginnerMathBlocks(): void {
  defineBlocksWithJsonArray(mathBlockDefinitions);
}
